import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { boletoBancarioLinhaDigitavel, boletoArrecadacaoLinhaDigitavel } from 'boleto-brasileiro-validator';
import {
  confirmed,
  email,
  max,
  min,
  min_value,
  max_value,
  numeric,
  required,
  excluded,
} from 'vee-validate/dist/rules';
import CpfValidate from './utils/identity';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);


// In order to validations work, we must declare/import which rules we want use.
// extend('rule_name', rule_imported)

extend('isBetweenAndSpecific', {
  validate: (value, { min, max, specificvalue }) => {
    if ((value >= min && value <= max) || value == specificvalue)
      return true;
    else
      return false
  },
  params: ['min', 'max', 'specificvalue'],
  message: (value, { min, max, specificvalue }) => {
    return 'O valor deve estar entre ' + min + ' e ' + max + ' ou deve ser especificamente ' + specificvalue + '.';
  }
});

extend('confirmed', {
  ...confirmed,
  message: 'A confirmação não confere.'
});

extend('required', {
  ...required, // Adding all the object props of imported rule.
  message: 'O campo é obrigatório' // Overriding the message.
});

extend('min', {
  ...min,
  message(field, { length }) {
    return 'O campo deve conter pelo menos ' + length + ' caracteres';
  }
});

extend('max', {
  ...max,
  message(field, { length }) {
    return 'O campo deve conter no máximo ' + length + ' caracteres';
  }
});

extend('numeric', {
  ...numeric,
  message: 'Somente números são aceitos'
});

extend('email', {
  ...email,
  message: 'O campo deve ser um e-mail válido'
});

extend('excluded', {
  ...excluded,
  message(field, { _value_ }) {
    if (isNaN(_value_)) {
      return 'O campo não pode ser ' + _value_;
    } else {
      return 'O valor não pode ser ' + _value_;
    }
  }
});

extend('min_value', {
  ...min_value,
  message(field, { min }) {
    return 'O valor deve ser maior que ' + min;
  }
});

extend('max_value', {
  ...max_value,
  message(field, { max }) {
    return 'O valor deve ser menor que ' + max;
  }
});

extend('identity', {
  validate: value => CpfValidate(value),
  message(field) {
    return 'O CPF informado é inválido';
  }
});

extend('name', {
  validate: value => {
    const re = new RegExp("[^A-Za-z ]");
    return !re.test(value);
  },
  message: 'O campo possui caracter(es) especial(is)'
});

extend('repeatedCharacters', {
  validate: value => {
    const re = new RegExp("([0-9])\\1{5,}");
    return !re.test(value);
  },
  message: 'Digite um telefone válido'
});

extend('frequency', {
  validate: value => {
    return value >= 1;
  },
  message: 'Selecione uma periodicidade'
});

extend('invalidIssueDate', {
  validate: () => { return false },
  message: 'A data de emissão deve ser maior que a data de competência'
});

extend('invalidDueDate', {
  validate: () => { return false },
  message: 'A data de vencimento deve ser maior que a data de Emissão'
});

extend('invalidRangeDate', {
  validate: () => { return false },
  message: 'A data inicial deve ser menor que a data final'
});

extend('invalidRangeValue', {
  validate: () => { return false },
  message: 'O valor inicial deve ser menor que o valor final'
});

extend('bankSlip', {
  validate: (value) => { return boletoBancarioLinhaDigitavel(value) || boletoArrecadacaoLinhaDigitavel(value) },
  message: 'Linha digitável inválida'
});



// WEBPACK FOOTER //
// ./src/vee-validate.js